import React from 'react';
import {toTitleCase} from "services/string";
import MessageChannel from "types/MessageChannel";

// Types ----

type ChannelSelectProps = {
  id: string
  name: string
  label: string
  value?: number | string | null
  onChange: (channel: MessageChannel | null) => any
}

// Component ----

function ChannelSelect({id, name, label, value, onChange}: ChannelSelectProps) {
  const channels = Object.values(MessageChannel);

  function handleChange(value: string | null) {
    onChange(value === null || value === '' ? null : value as MessageChannel)
  }

  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>

      <select
        id={id}
        name={name}
        className="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-brand focus:outline-none focus:ring-brand sm:text-sm"
        value={value ?? undefined}
        onChange={event => handleChange(event.currentTarget.value)}
      >
        <option value="">Any Channel</option>

        {channels.map(channel => (
          <option value={channel} key={channel}>
            {toTitleCase(channel)}
          </option>
        ))}
      </select>
    </div>
  );
}

export default ChannelSelect;